<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="模板编号" prop="code">
        <Input v-model="form.code" :maxlength="128"></Input>
      </FormItem>
      <FormItem label="模板名称" prop="name">
        <Input v-model="form.name" :maxlength="128"></Input>
      </FormItem>
<!--       <FormItem label="模板类型" prop="templateType">
        <sl-select v-model="form.templateType" type="radio" dict="$examTplType"></sl-select>
      </FormItem> -->
      <FormItem label="适用证照" prop="licenseIds">
        <license-select v-model="form.licenseIds" />
      </FormItem>
      <!-- <FormItem label="所属机构" prop="organizeId">
        <sl-select v-model="form.organizationId" dict="org" :filterable="true" @on-change="handleChangeOrg" :full-props="true"></sl-select>
      </FormItem> -->
      <FormItem label="总分" prop="totalScore">
        <InputNumber :step="1" :min="1" :active-change="false" v-model="form.totalScore"></InputNumber>
      </FormItem>
      <FormItem label="分数线" prop="passScore">
        <InputNumber :step="1" :min="1" :active-change="false" v-model="form.passScore"></InputNumber>
      </FormItem>
      <FormItem label="是否有效" prop="state">
        <sl-select v-model="form.state" type="radio" dict="$state"></sl-select>
      </FormItem>
      <FormItem label="模板内容" prop="settings">
        <tpl-structure :data="structures" @on-update="handleUpdate"></tpl-structure>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
import tplStructure from './structure'
import licenseSelect from '../../license/partial/license-select'

export default {
  components: { tplStructure , licenseSelect },
  data() {
    return {
      rules: {
        name: [{ required: true, message: '模板名称不能为空', trigger: 'blur,change' }],
        code: [{ required: true, message: '模板编号不能为空', trigger: 'blur,change' }],
        totalScore: [{ required: true, type:'number', message: '总分不能为空', trigger: 'blur,change' }],
        passScore: [{ required: true, type:'number', message: '分数线不能为空', trigger: 'blur,change' }],
        licenseIds:[{ type: 'array', required: true, message: '请选择适用证照', trigger: 'blur,change' }]

        // templateType: [{ type: 'number', required: true, message: '请选择模板类型', trigger: 'blur,change' }],
      },
      def: {},
      form: {
        id: null,
        // templateType: null,
        code: null,
        name: null,
        // organizeName: null,
        totalScore:null,
        passScore:null,
        districtCode:null,
        state:null,
        remark: null,
        license:null,
        licenseIds:null,
        settings:null
      },
      id: null,
      areaCode:null,
      area:[],
      modalVisible: false,
      loading: false,
      isCreate: true,
      options: [],
      structures:[],
    }
  },

  created() {
    this.def = { ...this.form }
  },

  computed: {
    itemTitle() {
      return this.id ? '编辑模板' : '添加模板'
    }
  },
  methods: {
    query() {
      // this.$request.ciEnterprise(this.id).then(resp => {
      this.$request.examTpl(this.id).then(resp => {
        resp.data.licenseIds = (resp.data.licenses || []).map(i => i.id)
        
        this.$utils.fill(this.form, resp.data)
        //this.areaCode = getDistrictCode([resp.data.province , resp.data.city, resp.data.area ])
        // console.log(this.areaCode)
        this.structures = resp.data.settings.map(i => ({ type:i.type , score:i.score , totalNum : i.totalNum}))
      })
    },

    init(id) {
      this.id = id
      this.reset()
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    reset() {
      this.$refs['form'].resetFields()
      this.$utils.fill(this.form, this.def)
      this.area = []
      this.structures = []
    },


    save() {
      //
      let params = { ...this.form }

      params.province = this.area[0]
      params.city = this.area[1]
      params.area = this.area[2]

      params.settings = this.structures
      this.loading = true

      let exec = this.id ? this.$request.examTplUpdate : this.$request.examTplCreate
      exec(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('update')
          this.modalVisible = false
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },

    handleUpdate(settings){
      this.structures = settings
    },
    handleChangeOrg(data){
      if(data){
        this.form.organizeName = data.label
        this.form.organizationId = data.value
      }else{
        this.form.organizeName = null
        this.form.organizationId = null
      }
    },
    handleChangeArea(data){
      this.area = data.map(i => i.name)
    },
    handleClose() {
      this.$emit('on-update')
    },
  }
}

</script>
